import React from "react";
import "./Footer.css";
import { FaFacebookF, FaYoutube, FaGooglePlay } from "react-icons/fa";
import {
  FaGithubAlt,
  FaLinkedinIn,
  FaDribbble,
  FaFacebook,
} from "react-icons/fa";

function Footer() {
  return (
    <div class="footer-clean">
      <footer>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-sm-4 col-md-3 item">
              <h3>Karlo Sayosa</h3>
              <ul>
                <li>
                  <a href="#social">Build awesome websites and cool apps!</a>
                </li>
              </ul>
            </div>
            <div class="col-sm-4 col-md-3 item">
              <h3>Services</h3>
              <ul>
                <li>
                  <a href="#games">Web Design</a>
                </li>
                <li>
                  <a href="#games">Web Dev</a>
                </li>
              </ul>
            </div>
            <div class="col-sm-4 col-md-3 item">
              <h3>Quick Contact</h3>
              <ul>
                <li>
                  <a href="mailto:sayosaolrak@gmail.com">
                    sayosaolrak@gmail.com
                  </a>
                </li>
              </ul>
            </div>
            <div id="footer-social" class="col-lg-3 item social">
              <a href="https://github.com/kjs17" target="_blank">
                <FaGithubAlt className="footer-git" />
              </a>
              <a href="https://www.linkedin.com/in/kjs17" target="_blank">
                <FaLinkedinIn className="footer-li" />
              </a>
              <a href="https://www.facebook.com/karlo.sayosa" target="_blank">
                <FaFacebook className="footer-fb" />
              </a>
              <p class="copyright">Karlo Sayosa © 2023</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
